module.exports = __webpack_public_path__ + "static/projects-5c385e4069c1ba71c6c4c343c49f5508.png";